import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpService } from 'src/app/http.service';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-layout-document',
  templateUrl: './layout-document.component.html',
  styleUrls: ['./layout-document.component.scss']
})
export class LayoutDocumentComponent {

  public categories: any = [];
  public documents: any = [];
  public document: any = {};
  public category_id: string = "";
  public fragment: string | null = null;
  public document_uuid: string = "";
  public temp_documents: any = [];
  public search_query: any = "";
  public sidebarCollapsed: boolean = false;
  public downloading: boolean = false;

  constructor(private http: HttpService, private httpClient: HttpClient, private activatedRoute: ActivatedRoute, private router: Router) { 
    this.activatedRoute.fragment.subscribe(async (fragment) => {
      if(this.categories.length == 0) {
        await this.getCategoryList();
      }

      if(fragment) {
        this.fragment = fragment;
      } else {
        this.fragment = null;
      }

      if(!fragment) {
        fragment = this.categories[0]?.id;
      }

      this.category_id = fragment;

      await this.getDocumentList(fragment);
     
    });
    
    this.activatedRoute.params.subscribe((params) => {
      this.document_uuid = params['document_uuid'];
      this.getDocument(this.document_uuid);
    });

    this.activatedRoute.queryParams.subscribe((params) => {
      this.search_query = params['search'] ?? "";
    });
  }

  async getCategoryList() {
    const res:any = await this.http.post("/admin/document/category", {});
    this.categories = res.categories;
  }

  async getDocumentList(category_id) {
    const res:any = await this.http.post("/admin/document/list", {category_id: category_id});
    this.documents = res.documents;
    this.temp_documents = res.documents;
  }

  async getDocument(document_uuid: string) {
    const res:any = await this.http.post(`/admin/document/get`, {
      document_uuid: document_uuid
    })
    this.document = res.document;
  }

  back() {
    this.router.navigate(['/document']);
  }

  selectCategory(categoryId: string) {
    if (this.category_id == categoryId) {
      // Toggle off
      this.category_id = "";
      this.fragment = null;
      this.router.navigate(['/document']);
    } else {
      this.category_id = categoryId;
      this.fragment = categoryId;
      this.router.navigate(['/document'], { fragment: categoryId });
    }
  }

  search(event: any) {

    let qp:any = {}

    if(event.target.value && event.target.value.length > 0) {
      qp.search = event.target.value
      this.search_query = event.target.value;
    } else {
      this.search_query = "";
    }

    this.router.navigate(['/document'], { queryParams: qp, fragment: this.category_id });

    if(!event.target.value || event.target.value.length == 0) {
      this.temp_documents = this.documents;
      return;
    }


    this.temp_documents = this.documents.filter((document: any) => document.title.toLowerCase().includes(event.target.value.toLowerCase()));
  }

  async downloadPdf() {
    if (this.downloading) return;
    this.downloading = true;

    try {
      const access = this.http.getAccess();
      const body: any = {};
      if (access['uuid']) body.user_uuid = access['uuid'];

      const blob: Blob = await this.httpClient.post(
        environment.url + '/admin/document/download-all',
        body,
        { responseType: 'blob' }
      ).toPromise() as Blob;

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'documentation.pdf';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    } catch (e) {
      console.error('PDF download failed:', e);
    }

    this.downloading = false;
  }
}
